import { render, staticRenderFns } from "./ModuloCallCenter.vue?vue&type=template&id=c009efc6&"
import script from "./ModuloCallCenter.vue?vue&type=script&lang=js&"
export * from "./ModuloCallCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports